export default __webpack_public_path__ + "static/media/1.1525f3c0.jpg";